import { useState } from "react";
import { Button, Checkbox } from "..";
import PhoneInput from "../PhoneInput/PhoneInput";
import "./AuthForm.scss";
import { CaptchaWidget } from "../CaptchaWidget/CaptchaWidget";

function RegisterForm({
  onSwitchToLogin,
  onSubmit,
  errorMessage,
  registrationinng,
  setRegistrationing,
  setCaptchaToken,
}) {
  const [form, setForm] = useState({
    username: "",
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    phonePrefix: "+421",
    password: "",
    confirmPassword: "",
    agree: false,
  });

  const updateField = (key) => (e) => {
    const val = e?.target ? e.target.value : e;
    setForm((prev) => ({ ...prev, [key]: val }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setRegistrationing(true);
    onSubmit?.(form);
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <div className="auth-form__grid">
        <div className="auth-form__field">
          <label className="auth-form__label" htmlFor="reg-firstname">
            Meno
          </label>
          <input
            id="reg-firstname"
            type="text"
            className="auth-form__input"
            placeholder="Ján"
            required
            value={form.firstname}
            onChange={updateField("firstname")}
            autoComplete="given-name"
          />
        </div>
        <div className="auth-form__field">
          <label className="auth-form__label" htmlFor="reg-lastname">
            Priezvisko
          </label>
          <input
            id="reg-lastname"
            type="text"
            className="auth-form__input"
            placeholder="Novák"
            required
            value={form.lastname}
            onChange={updateField("lastname")}
            autoComplete="family-name"
          />
        </div>
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="reg-username">
          Prihlasovacie meno
        </label>
        <input
          id="reg-username"
          type="text"
          className="auth-form__input"
          placeholder="jan.novak"
          required
          value={form.username}
          onChange={updateField("username")}
          autoComplete="username"
          autoCapitalize="none"
          spellCheck={false}
        />
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="reg-phone">
          Telefónne číslo
        </label>
        <PhoneInput
          id="reg-phone"
          value={form.phone}
          prefix={form.phonePrefix}
          onChange={(val) => setForm((prev) => ({ ...prev, phone: val }))}
          onPrefixChange={(val) => setForm((prev) => ({ ...prev, phonePrefix: val }))}
        />
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="reg-email">
          Email
        </label>
        <input
          id="reg-email"
          type="email"
          className="auth-form__input"
          placeholder="vas@email.com"
          value={form.email}
          required
          onChange={updateField("email")}
          autoComplete="email"
        />
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="reg-password">
          Heslo
        </label>
        <input
          id="reg-password"
          type="password"
          className="auth-form__input"
          placeholder="Minimálne 8 znakov"
          value={form.password}
          required
          onChange={updateField("password")}
          autoComplete="new-password"
        />
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="reg-confirm">
          Potvrdenie hesla
        </label>
        <input
          id="reg-confirm"
          type="password"
          className="auth-form__input"
          placeholder="Zopakujte heslo"
          value={form.confirmPassword}
          required
          onChange={updateField("confirmPassword")}
          autoComplete="new-password"
        />
      </div>

      <Checkbox
        label="Súhlasím s obchodnými podmienkami a spracovaním osobných údajov"
        checked={form.agree}
        onChange={(val) => setForm((prev) => ({ ...prev, agree: val }))}
      />
      <CaptchaWidget onVerify={(token) => setCaptchaToken(token)} />
      {errorMessage && <p className="auth-form__error">{errorMessage}</p>}

      <div className="auth-form__submit">
        <Button
          variant="primary"
          type="submit"
          style={{ width: "100%" }}
          disabled={registrationinng}
        >
          {registrationinng ? "Registrujem..." : "Vytvoriť účet"}
        </Button>
      </div>

      {onSwitchToLogin && (
        <p className="auth-form__switch">
          Už máte účet?{" "}
          <button
            type="button"
            className="auth-form__link"
            onClick={onSwitchToLogin}
          >
            Prihláste sa
          </button>
        </p>
      )}
    </form>
  );
}

export default RegisterForm;
